const Delta = ({ as: Node = 'h4', children, className = '', ...props }) => (
  <Node
    className={[`text-delta-fluid font-bold`, className].join(' ').trim()}
    {...props}
  >
    {children}
  </Node>
)

export default Delta
